import React, { useState } from "react";
import { Container, Row, Col, Modal, Button } from "react-bootstrap";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { IoLocationOutline, IoCallOutline, IoShieldCheckmarkOutline } from "react-icons/io5";
import { MdOutlineLocalShipping, MdContentCopy } from "react-icons/md";
import { FaWhatsapp, FaCreditCard, FaChevronRight, FaQrcode } from "react-icons/fa";
import WhatsAppButton from "./Whatsapp";

const Footer = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleNavigate = () => {
    navigate("/");
  };

  const [showQRModal, setShowQRModal] = useState(false);
  const [copiedField, setCopiedField] = useState(null);

  const copyToClipboard = (text, field) => {
    if (navigator?.clipboard?.writeText) {
      navigator.clipboard.writeText(text);
      setCopiedField(field);
      setTimeout(() => setCopiedField(null), 2000);
    }
  };

  const mapLink =
    "https://maps.app.goo.gl/jWAZ4TpUUehJfpnB6";

  return (
    <>
      {/* Floating Quick Action Buttons */}
      {location.pathname !== "/" && (
        <div className="fixed point2 blink" onClick={handleNavigate} title="Quick Purchase">
          <img
            src={require("../../assets/images/quickpurchase.png")}
            className="img-fluid priceicn2 float-right"
            alt="special price"
          />
        </div>
      )}

      {location.pathname !== "/" && location.pathname !== "/products" && (
        <>
          <div className="fixed point" title="WhatsApp Us">
            <WhatsAppButton name="Sivakasi Market Price" phoneNumber="+91 9123527915" />
          </div>
          <a href={mapLink} target="_blank" rel="noreferrer" title="Store Location">
            <div className="fixed point3" style={{ cursor: "pointer" }}>
              <img
                src={require("../../assets/images/googlelocation.png")}
                className="img-fluid priceicn float-left"
                alt="Store location"
              />
            </div>
          </a>
          <a href="tel:+919123527915" title="Call Us">
            <div className="fixed point4" style={{ cursor: "pointer" }}>
              <img
                src={require("../../assets/images/callicon.webp")}
                className="img-fluid priceicn float-left"
                alt="Call Us"
              />
            </div>
          </a>
        </>
      )}

      {/* Main Luxury Footer Section */}
      <footer
        className="footer-section position-relative pt-5 pb-4"
        style={{
          background: "linear-gradient(180deg, #3D0710 0%, #240409 100%)",
          color: "#FFF8E7",
          borderTop: "4px solid #F4B942",
          boxShadow: "0 -10px 30px rgba(0, 0, 0, 0.35)",
        }}
      >
        <Container>
          {/* Trust Banner Strip */}
          <div
            className="p-3 mb-5 rounded-4 d-flex flex-wrap justify-content-around align-items-center gap-3"
            style={{
              background: "linear-gradient(135deg, rgba(16, 31, 66, 0.9) 0%, rgba(61, 7, 16, 0.95) 100%)",
              border: "1px solid rgba(255, 215, 0, 0.35)",
              backdropFilter: "blur(8px)",
              boxShadow: "0 4px 20px rgba(0, 0, 0, 0.2)",
            }}
          >
            <div className="d-flex align-items-center gap-2">
              <IoShieldCheckmarkOutline size={26} color="#F4B942" />
              <span className="fw-bold" style={{ color: "#FFF8E7", fontSize: "0.95rem" }}>
                100% Genuine Sivakasi Fireworks
              </span>
            </div>
            <div className="d-flex align-items-center gap-2">
              <MdOutlineLocalShipping size={26} color="#F4B942" />
              <span className="fw-bold" style={{ color: "#FFF8E7", fontSize: "0.95rem" }}>
                Safe & Fast Transport Dispatch
              </span>
            </div>
            <div className="d-flex align-items-center gap-2">
              <FaCreditCard size={24} color="#F4B942" />
              <span className="fw-bold" style={{ color: "#FFF8E7", fontSize: "0.95rem" }}>
                Wholesale & Retail Direct Factory Rates
              </span>
            </div>
          </div>

          <Row className="g-4 pb-4">
            {/* Column 1: Brand & Logo Showcase */}
            <Col lg={4} md={6} className="text-center text-md-start">
              <div className="d-flex flex-column align-items-center align-items-md-start">
                <div
                  className="mb-3 p-2 bg-white rounded-circle d-inline-block"
                  style={{
                    boxShadow: "0 8px 25px rgba(123, 15, 28, 0.35)",
                    border: "3px solid #7B0F1C",
                    width: "130px",
                    height: "130px",
                  }}
                >
                  <img
                    src={require("../../assets/images/logosm.png")}
                    alt="Sivakasi Market Price Logo"
                    className="w-100 h-100 rounded-circle object-fit-contain"
                  />
                </div>
                <h4
                  className="fw-bold mb-1"
                  style={{
                    color: "#F4B942",
                    fontFamily: "serif",
                    letterSpacing: "1px",
                    fontSize: "1.35rem",
                  }}
                >
                  SIVAKASI MARKET PRICE
                </h4>
                <p className="mb-2" style={{ color: "#FDE68A", fontSize: "0.88rem", fontWeight: "600" }}>
                  Shri Thiruppathi Hariharan Crackers | Wholesale & Retail
                </p>
                <p className="small text-white-50" style={{ lineHeight: "1.6", maxWidth: "330px" }}>
                  Direct factory prices, genuine quality fireworks, direct sales, and lowest Sivakasi market price for
                  safe celebrations across India.
                </p>
              </div>
            </Col>

            {/* Column 2: Quick Links */}
            <Col lg={2} md={6} sm={6}>
              <div className="ps-lg-3">
                <h5
                  className="fw-bold mb-3 pb-2 position-relative"
                  style={{
                    color: "#F4B942",
                    fontSize: "1.1rem",
                    borderBottom: "2px solid rgba(245, 158, 11, 0.3)",
                  }}
                >
                  Quick Links
                </h5>
                <ul className="list-unstyled mb-0 d-flex flex-column gap-2">
                  <li>
                    <Link
                      to="/home"
                      className="d-flex align-items-center gap-1 text-white-50 text-decoration-none footer-nav-item"
                    >
                      <FaChevronRight size={11} color="#F59E0B" /> Home
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/about"
                      className="d-flex align-items-center gap-1 text-white-50 text-decoration-none footer-nav-item"
                    >
                      <FaChevronRight size={11} color="#F59E0B" /> About Us
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/"
                      className="d-flex align-items-center gap-1 text-decoration-none footer-nav-item fw-bold"
                      style={{ color: "#FCD34D" }}
                    >
                      <FaChevronRight size={11} color="#F59E0B" /> Price List 2026 💥
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/safetytips"
                      className="d-flex align-items-center gap-1 text-white-50 text-decoration-none footer-nav-item"
                    >
                      <FaChevronRight size={11} color="#F59E0B" /> Safety Tips
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/contactus"
                      className="d-flex align-items-center gap-1 text-white-50 text-decoration-none footer-nav-item"
                    >
                      <FaChevronRight size={11} color="#F59E0B" /> Contact Us
                    </Link>
                  </li>
                </ul>
              </div>
            </Col>

            {/* Column 3: Store & Reach Us */}
            <Col lg={3} md={6}>
              <h5
                className="fw-bold mb-3 pb-2 position-relative"
                style={{
                  color: "#F4B942",
                  fontSize: "1.1rem",
                  borderBottom: "2px solid rgba(245, 158, 11, 0.3)",
                }}
              >
                Store & Reach Us
              </h5>
              <div className="d-flex flex-column gap-3">
                {/* Location */}
                <a
                  href={mapLink}
                  target="_blank"
                  rel="noreferrer"
                  className="text-decoration-none text-white-50 d-flex gap-2 align-items-start"
                >
                  <div
                    className="p-1 rounded-circle flex-shrink-0 d-flex align-items-center justify-content-center"
                    style={{ background: "#7B0F1C", border: "1px solid #F4B942", width: "32px", height: "32px" }}
                  >
                    <IoLocationOutline size={18} color="#F4B942" />
                  </div>
                  <div style={{ fontSize: "0.88rem", lineHeight: "1.4" }}>
                    <strong className="text-white d-block">Store Address:</strong>
                    8-392-A, Indian Oil Petrol Pump Backside, Naranapuram, Sivakasi - 626189
                  </div>
                </a>

                {/* Call */}
                <div className="d-flex gap-2 align-items-start">
                  <div
                    className="p-1 rounded-circle flex-shrink-0 d-flex align-items-center justify-content-center"
                    style={{ background: "#7B0F1C", border: "1px solid #F4B942", width: "32px", height: "32px" }}
                  >
                    <IoCallOutline size={18} color="#F4B942" />
                  </div>
                  <div style={{ fontSize: "0.88rem" }}>
                    <strong className="text-white d-block">Phone Helpline:</strong>
                    <a href="tel:+919123527915" className="text-white-50 text-decoration-none d-inline-block me-2">
                      +91 91235 27915
                    </a>
                    <br />
                    <a href="tel:+918248114500" className="text-white-50 text-decoration-none d-inline-block">
                      +91 82481 14500
                    </a>
                  </div>
                </div>

                {/* WhatsApp */}
                <div className="d-flex gap-2 align-items-center">
                  <div
                    className="p-1 rounded-circle flex-shrink-0 d-flex align-items-center justify-content-center"
                    style={{ background: "#25D366", width: "32px", height: "32px" }}
                  >
                    <FaWhatsapp size={18} color="#FFFFFF" />
                  </div>
                  <div style={{ fontSize: "0.88rem" }}>
                    <a
                      href="https://wa.me/919123527915?text=Hello%20Sivakasi%20Market%20Price"
                      target="_blank"
                      rel="noreferrer"
                      className="text-white text-decoration-none fw-bold"
                    >
                      WhatsApp: +91 91235 27915 / 82481 14500
                    </a>
                  </div>
                </div>

                {/* Secondary Helpline */}
                <div className="d-flex gap-2 align-items-center">
                  <div
                    className="p-1 rounded-circle flex-shrink-0 d-flex align-items-center justify-content-center"
                    style={{ background: "#7B0F1C", border: "1px solid #F59E0B", width: "32px", height: "32px" }}
                  >
                    <IoCallOutline size={18} color="#F4B942" />
                  </div>
                  <div style={{ fontSize: "0.88rem" }}>
                    <a href="tel:+918248114500" className="text-white-50 text-decoration-none">
                      Helpline: +91 82481 14500
                    </a>
                  </div>
                </div>
              </div>
            </Col>

            {/* Column 4: Payment & Location Map Link */}
            {/* Column 4: Payment & Location Map Link */}
            <Col lg={3} md={6}>
              <h5
                className="fw-bold mb-3 pb-2 position-relative"
                style={{
                  color: "#F4B942",
                  fontSize: "1.1rem",
                  borderBottom: "2px solid rgba(245, 158, 11, 0.3)",
                }}
              >
                Payment Options
              </h5>
              <p className="small text-white-50 mb-2" style={{ fontSize: "0.82rem" }}>
                Accepting Google Pay, PhonePe & UPI for direct orders:
              </p>

              <div className="d-flex flex-column gap-2 mb-3">
                {/* GPay Number Card */}
                <div
                  className="rounded-3 d-flex align-items-center justify-content-between"
                  style={{
                    background: "rgba(255, 255, 255, 0.08)",
                    border: "1px solid rgba(245, 158, 11, 0.35)",
                    padding: "10px 14px",
                  }}
                >
                  <div className="d-flex align-items-center gap-2">
                    <span
                      className="px-2 py-0.5 rounded small fw-bold"
                      style={{ background: "#1a73e8", color: "#FFFFFF", fontSize: "0.72rem" }}
                    >
                      GPay
                    </span>
                    <a
                      href="tel:8531964818"
                      className="fw-bold text-decoration-none"
                      style={{ color: "#FFF8E7", fontSize: "0.88rem", letterSpacing: "0.5px" }}
                    >
                      8531964818
                    </a>
                  </div>
                  <button
                    type="button"
                    className="btn btn-sm py-0 px-2 border-0 text-warning"
                    onClick={() => copyToClipboard("8531964818", "gpay")}
                    title="Copy GPay Number"
                    style={{ background: "transparent" }}
                  >
                    {copiedField === "gpay" ? (
                      <span className="badge bg-success" style={{ fontSize: "0.68rem" }}>Copied!</span>
                    ) : (
                      <MdContentCopy size={15} color="#F4B942" />
                    )}
                  </button>
                </div>

                {/* PhonePe Number Card */}
                <div
                  className="rounded-3 d-flex align-items-center justify-content-between"
                  style={{
                    background: "rgba(255, 255, 255, 0.08)",
                    border: "1px solid rgba(245, 158, 11, 0.35)",
                    padding: "10px 14px",
                  }}
                >
                  <div className="d-flex align-items-center gap-2">
                    <span
                      className="px-2 py-0.5 rounded small fw-bold"
                      style={{ background: "#5f259f", color: "#FFFFFF", fontSize: "0.72rem" }}
                    >
                      PhonePe
                    </span>
                    <a
                      href="tel:9123527915"
                      className="fw-bold text-decoration-none"
                      style={{ color: "#FFF8E7", fontSize: "0.88rem", letterSpacing: "0.5px" }}
                    >
                      9123527915
                    </a>
                  </div>
                  <button
                    type="button"
                    className="btn btn-sm py-0 px-2 border-0 text-warning"
                    onClick={() => copyToClipboard("9123527915", "phonepe")}
                    title="Copy PhonePe Number"
                    style={{ background: "transparent" }}
                  >
                    {copiedField === "phonepe" ? (
                      <span className="badge bg-success" style={{ fontSize: "0.68rem" }}>Copied!</span>
                    ) : (
                      <MdContentCopy size={15} color="#F4B942" />
                    )}
                  </button>
                </div>

                {/* UPI ID Card */}
                <div
                  className="rounded-3 d-flex align-items-center justify-content-between"
                  style={{
                    background: "rgba(255, 255, 255, 0.08)",
                    border: "1px solid rgba(245, 158, 11, 0.35)",
                    padding: "10px 14px",
                  }}
                >
                  <div className="d-flex align-items-center gap-2 overflow-hidden">
                    <span
                      className="px-1.5 py-0.5 rounded small fw-bold flex-shrink-0"
                      style={{ background: "#00796B", color: "#FFFFFF", fontSize: "0.7rem" }}
                    >
                      UPI ID
                    </span>
                    <span
                      className="text-white-50 text-truncate"
                      style={{ fontSize: "0.76rem" }}
                      title="thiruppathihariharancrackers@tmb"
                    >
                      thiruppathihariharancrackers@tmb
                    </span>
                  </div>
                  <button
                    type="button"
                    className="btn btn-sm py-0 px-1 border-0 text-warning flex-shrink-0"
                    onClick={() => copyToClipboard("thiruppathihariharancrackers@tmb", "upi")}
                    title="Copy UPI ID"
                    style={{ background: "transparent" }}
                  >
                    {copiedField === "upi" ? (
                      <span className="badge bg-success" style={{ fontSize: "0.68rem" }}>Copied!</span>
                    ) : (
                      <MdContentCopy size={15} color="#F4B942" />
                    )}
                  </button>
                </div>
              </div>

              {/* QR Code Scan & Pay Button */}
              <button
                type="button"
                className="btn w-100 fw-bold py-2 mb-2 d-flex align-items-center justify-content-center gap-2"
                onClick={() => setShowQRModal(true)}
                style={{
                  background: "linear-gradient(135deg, #F4B942 0%, #F59E0B 100%)",
                  color: "#3D0710",
                  borderRadius: "8px",
                  boxShadow: "0 4px 15px rgba(255, 215, 0, 0.3)",
                  fontSize: "0.86rem",
                }}
              >
                <FaQrcode size={16} />
                Scan QR Code to Pay
              </button>

              <a
                href={mapLink}
                target="_blank"
                rel="noreferrer"
                className="btn w-100 fw-bold py-1.5 text-decoration-none text-center"
                style={{
                  background: "rgba(255, 255, 255, 0.08)",
                  color: "#FDE68A",
                  border: "1px solid rgba(245, 158, 11, 0.35)",
                  borderRadius: "8px",
                  fontSize: "0.82rem",
                }}
              >
                📍 View Sivakasi Location
              </a>
            </Col>
          </Row>
        </Container>

        {/* QR Code Modal in Footer */}
        <Modal show={showQRModal} onHide={() => setShowQRModal(false)} centered size="md">
          <Modal.Header
            closeButton
            style={{
              background: "#3D0710",
              color: "#F4B942",
              borderBottom: "2px solid #F4B942",
            }}
          >
            <Modal.Title style={{ fontSize: "1.1rem", fontWeight: "bold", color: "#F4B942" }}>
              💳 Scan QR Code to Pay
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="text-center p-3" style={{ background: "#FFFDF9" }}>
            <h6 className="fw-bold mb-1" style={{ color: "#7B0F1C" }}>
              SRI THIRUPPATHI HARIHARAN CRACKERS
            </h6>
            <p className="small text-muted mb-2">
              Tamilnad Mercantile Bank Ltd (TMB) | Receive money from any UPI App
            </p>
            <div className="d-flex justify-content-center mb-2">
              <img
                src={require("../../assets/images/payment_qr.jpg")}
                alt="Sri Thiruppathi Hariharan Crackers Payment QR"
                className="img-fluid rounded-3 shadow-sm"
                style={{
                  maxHeight: "380px",
                  maxWidth: "100%",
                  border: "2px solid #E5E7EB",
                  padding: "6px",
                  background: "#fff",
                }}
              />
            </div>
            <div className="p-2.5 rounded-3 text-start" style={{ background: "#FEF3C7", border: "1px solid #F59E0B" }}>
              <div className="d-flex justify-content-between align-items-center mb-1">
                <span className="small fw-bold text-dark">GPay No:</span>
                <span className="fw-bold" style={{ color: "#1a73e8" }}>8531964818</span>
              </div>
              <div className="d-flex justify-content-between align-items-center mb-1">
                <span className="small fw-bold text-dark">PhonePe No:</span>
                <span className="fw-bold" style={{ color: "#5f259f" }}>9123527915</span>
              </div>
              <div className="d-flex justify-content-between align-items-center">
                <span className="small fw-bold text-dark">UPI ID:</span>
                <span className="small fw-bold text-dark font-monospace">thiruppathihariharancrackers@tmb</span>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer style={{ background: "#FFFDF9", borderTop: "1px solid #E5E7EB" }}>
            <a
              href="/payment_qr.jpg"
              download="Sivakasi_Market_Price_Payment_QR.jpg"
              className="btn btn-sm btn-outline-danger fw-bold"
            >
              📥 Download QR Code
            </a>
            <Button variant="secondary" size="sm" onClick={() => setShowQRModal(false)}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Bottom Copyright Strip */}
        <div
          className="pt-3 mt-3 text-center"
          style={{
            borderTop: "1px solid rgba(255, 215, 0, 0.2)",
            background: "#240409",
          }}
        >
          <Container>
            <p className="mb-0 text-white-50 small">
              Copyright © 2026, <strong style={{ color: "#F4B942" }}>Sivakasi Market Price</strong> (Shri Thiruppathi Hariharan Crackers). All rights reserved.
              <span className="d-block d-sm-inline ms-sm-2">Naranapuram, Sivakasi - 626189, Tamil Nadu.</span>
            </p>
          </Container>
        </div>
      </footer>
    </>
  );
};

export default Footer;
